/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface TrademarkRequestList200ResponseMetaCountByStatusInner
 */
export interface TrademarkRequestList200ResponseMetaCountByStatusInner {
  /**
   *
   * @type {number}
   * @memberof TrademarkRequestList200ResponseMetaCountByStatusInner
   */
  status: TrademarkRequestList200ResponseMetaCountByStatusInnerStatusEnum
  /**
   *
   * @type {number}
   * @memberof TrademarkRequestList200ResponseMetaCountByStatusInner
   */
  count: number
}

/**
 * @export
 * @enum {string}
 */
export enum TrademarkRequestList200ResponseMetaCountByStatusInnerStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
}

/**
 * Check if a given object implements the TrademarkRequestList200ResponseMetaCountByStatusInner interface.
 */
export function instanceOfTrademarkRequestList200ResponseMetaCountByStatusInner(
  value: object
): value is TrademarkRequestList200ResponseMetaCountByStatusInner {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('count' in value) || value['count'] === undefined) return false
  return true
}

export function TrademarkRequestList200ResponseMetaCountByStatusInnerFromJSON(
  json: any
): TrademarkRequestList200ResponseMetaCountByStatusInner {
  return TrademarkRequestList200ResponseMetaCountByStatusInnerFromJSONTyped(
    json,
    false
  )
}

export function TrademarkRequestList200ResponseMetaCountByStatusInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TrademarkRequestList200ResponseMetaCountByStatusInner {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    count: json['count'],
  }
}

export function TrademarkRequestList200ResponseMetaCountByStatusInnerToJSON(
  value?: TrademarkRequestList200ResponseMetaCountByStatusInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    count: value['count'],
  }
}
